module.exports = __webpack_public_path__ + "static/fipcneutralhelloworld-bcb45fcdb31d81b378ec141bf3229562.jpeg";